import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/settings/employee-types/`;

export const fetchEmployeeTypes = createAsyncThunk(
  'employeeTypes/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Fetch failed');
    }
  }
);

export const addEmployeeType = createAsyncThunk(
  'employeeTypes/add',
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(BASE_URL, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Add failed');
    }
  }
);

export const updateEmployeeType = createAsyncThunk(
  'employeeTypes/update',
  async ({ id, ...data }, thunkAPI) => {
    try {
      const response = await axios.put(`${BASE_URL}${id}/`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Update failed');
    }
  }
);

export const deleteEmployeeType = createAsyncThunk(
  'employeeTypes/delete',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}${id}/`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Delete failed');
    }
  }
);

const employeeTypesSlice = createSlice({
  name: 'employeeTypes',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchEmployeeTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addEmployeeType.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateEmployeeType.fulfilled, (state, action) => {
        const index = state.items.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(deleteEmployeeType.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.id !== action.payload);
      });
  }
});

export default employeeTypesSlice.reducer;
